import { useAssociations } from '../useAssociations';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const AssociationCount = ({
  subject,
  primaryAssociationDefinition,
  secondaryAssociationDefinition,
  getAssociationData
}) => {
  const hasCustomAssociationGetter = typeof getAssociationData === 'function';
  const associations = useAssociations(subject.objectId, hasCustomAssociationGetter, primaryAssociationDefinition, secondaryAssociationDefinition);
  const lookup = hasCustomAssociationGetter ? getAssociationData(subject.objectId) : associations;
  if (!lookup || lookup.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "cdbc-associations-count",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-data-board-card.associationCount.message",
      options: {
        count: lookup.length
      }
    })
  });
};
export default AssociationCount;